import withNextGenISR from '../../../utils/withNextGenISR';
import { CommonDataProps, Content, PageCategory } from '../../../types/common';
import { getInvalidateTime } from '../../../utils/common';
import ContentDetail, { getContentDetail } from 'components/ContentDetail/ContentDetail';
import SEOComponent from 'components/SEOComponent/SEOComponent';
import withFeatureFlags from 'utils/withFeatureFlags';

const ContentPage = (props: CommonDataProps) => {
  const { title = '', tagline = '' } = props?.data?.hero_section?.article_overview?.[0]?.overview || {};
  return (
    <>
      <SEOComponent />
      <ContentDetail type={Content.articles} {...props} title={title} tagline={tagline} />
    </>
  );
};

export const getStaticPaths = () => ({
  paths: [],
  fallback: 'blocking',
});

export const getStaticProps = withNextGenISR(async (context) => {
  const { data, showError, notFoundData } = await getContentDetail(context, Content.articles);

  return {
    props: {
      data,
      showError,
      notFoundPageData: notFoundData,
      params: context.params,
    },
    revalidate: getInvalidateTime(PageCategory.DEFERRED),
  };
});
export default withFeatureFlags(ContentPage);
